export const buildComparator =
  <T>(evaluate: (obj: T) => boolean | number | string, order: 'asc' | 'desc' = 'asc'): ((a: T, b: T) => number) =>
  (a, b) => {
    const valA = evaluate(a);
    const valB = evaluate(b);
    const orderFactor = order === 'asc' ? 1 : -1;
    if (valA < valB) {
      return -orderFactor;
    } else if (valA > valB) {
      return orderFactor;
    } else {
      return 0;
    }
  };
